module.exports = __webpack_public_path__ + "img/03.86201c0e.png";